import { render, staticRenderFns } from "./auto_scroll.vue?vue&type=template&id=5060884a&scoped=true&"
import script from "./auto_scroll.vue?vue&type=script&lang=js&"
export * from "./auto_scroll.vue?vue&type=script&lang=js&"
import style0 from "./auto_scroll.vue?vue&type=style&index=0&id=5060884a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5060884a",
  null
  
)

export default component.exports